import { render, staticRenderFns } from "./deviceMng.vue?vue&type=template&id=ddbbcdf6&scoped=true"
import script from "./deviceMng.vue?vue&type=script&lang=js"
export * from "./deviceMng.vue?vue&type=script&lang=js"
import style0 from "./deviceMng.vue?vue&type=style&index=0&id=ddbbcdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbbcdf6",
  null
  
)

export default component.exports